<template>
    <div class="container">
        <div class="pt-5">
            <h1 class="h3">Settings</h1>
            <div class="py-2">
             
                <settings-menu></settings-menu>
            </div>
            <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
            <h3 class="h3">Reports settings</h3>
            <small>View and update reports settings </small>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="float-right">
                    <button @click="saveReportSettings()" class="btn btn-primary px-3">Save Changes</button>
                </div>
                </div>
                </div>
         
            <div class="container text-left mb-5">
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Daily Reports <small class="text-danger">*</small></h6>
                        <small>
                              Receive daily sales reports
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="reportSettings.dailyReports" id="daily-reports">
                            <label class="custom-control-label" for="daily-reports"><small>Send me daily reports</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Weekly Reports <small class="text-danger">*</small></h6>
                        <small>
                              Receive weekly sales reports
                              (On Monday)
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="reportSettings.weeklyReports" id="weekly-report">
                            <label class="custom-control-label" for="weekly-report"><small>Send me weekly reports</small></label>
                        </div>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Monthly Reports <small class="text-danger">*</small></h6>
                        <small>
                              Receive monthly sales reports
                              (On first day of every month)
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="reportSettings.monthlyReports" id="monthly-reports">
                            <label class="custom-control-label" for="monthly-reports"><small>Send me monthly reports</small></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        name: "profile",
        data() {
            return {
                reportSettings: {
                    dailyReports:1,
                    weeklyReports:1,
                    monthlyReports:1
                }
            }
        },
        mounted() {
            this.getUserCompanySettings()
        },
        methods: {
            
            getUserCompanySettings() {
                axios.get('/api/settings')
                    .then(results => {
                       this.reportSettings.dailyReports = results.data.daily_reports
                       this.reportSettings.weeklyReports = results.data.weekly_reports
                       this.reportSettings.monthlyReports = results.data.monthly_reports
                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            saveReportSettings() {
                axios.post('/api/settings/reports', { ...this.reportSettings
                }).then(results => {
                    if(results.status === 200)
                    {
                        this.$toasts.push({
                        type: 'success',
                        message: "Settings updated"
                         })
                         window.location.replace('/settings/reports')
                    }
                   
                }).catch(errors => {
                })
            }
        },
    }
</script>

<style scoped>

</style>